import { useTranslation } from 'react-i18next'
import { useField } from 'formik'
import { FormControl } from '@mui/material'

import { ListWagerType } from '@/enums'
import AutocompleteCustom from '@/views/components/autocomplete-custom/index.component'

type Props = {
  handleChangeSearch: (field: string, value: any) => void
}

export const WagerTypesFilterType = ({ handleChangeSearch }: Props) => {
  const { t } = useTranslation()

  const [fieldWagerTypes] = useField('wagerTypes')

  const listWagerTypesObject = []
  const listWagerTypesOptions = []

  Object.values(ListWagerType).forEach((value) => {
    if (Number.isNaN(Number(value))) {
      const item = {
        name: t(`restrictionsItems.${value}`),
        id: value,
      }
      listWagerTypesOptions.push(value)
      listWagerTypesObject.push(item)
    }
  })

  return (
    <FormControl fullWidth margin="none">
      <AutocompleteCustom
        id="wagerTypes"
        name="wagerTypes"
        placeholder={
          fieldWagerTypes.value === '' || fieldWagerTypes.value.length === 0
            ? t('labels.selectWagerTypes')
            : ''
        }
        options={listWagerTypesOptions}
        getOptionLabel={(option: any) =>
          listWagerTypesObject.find((sportOption) => sportOption.id === option)
            ?.name || ''
        }
        limitTags={2}
        multiple
        value={fieldWagerTypes.value}
        onChange={(_, newValue: any | null) => {
          handleChangeSearch('wagerTypes', newValue)
        }}
        label={t('labels.wagerTypes')}
        sx={{ '& .MuiFormControl-root': { marginTop: '8px' } }}
      />
    </FormControl>
  )
}
